import React from 'react';

const SPLITS = [0.25, 0.5, 0.75, 1];

const fmt = (n) =>
  n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: 12,
  },
  card: {
    border: '1px solid #E5E7EB',
    borderRadius: 10,
    padding: '14px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  cardCovered: {
    border: '1px solid #CDE8D6',
    background: '#F1FAF4',
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 600,
    color: '#4B5563',
  },
  amount: { fontSize: 22, fontWeight: 700, color: '#1F2328' },
  status: { fontSize: 13, fontWeight: 500 },
};

export default function PaymentMilestones({ total = 0, paid_amount = 0 }) {
  const totalNum = Number(total) || 0;
  const paidNum = Number(paid_amount) || 0;

  return (
    <div style={styles.grid}>
      {SPLITS.map((pct) => {
        const amount = Math.round(totalNum * pct * 100) / 100;
        const remaining = Math.max(0, Math.round((amount - paidNum) * 100) / 100);
        const covered = remaining === 0;

        return (
          <div
            key={pct}
            style={{ ...styles.card, ...(covered ? styles.cardCovered : {}) }}
          >
            <div style={styles.top}>
              {pct * 100}%
              {covered && (
                <svg
                  role="img"
                  aria-label="Covered"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#1E7A44"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12l5 5L20 7" />
                </svg>
              )}
            </div>
            <div style={styles.amount}>{fmt(amount)}</div>
            <div style={{ ...styles.status, color: covered ? '#1E7A44' : '#9A5800' }}>
              {covered ? 'Covered' : `${fmt(remaining)} to go`}
            </div>
          </div>
        );
      })}
    </div>
  );
}